import { ISSUE_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';

export const SELECT_ROW_COLUMN_ID = 'selectRow';
export const SUMMARY_FIELD_TYPE = 'summary';
export const CUSTOM_TEXT_FIELD_TYPE = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
export const COLUMN_DRAGGABLE_HELPER_CLASS = 'column-draggable-helper-class';
export const COLUMNS_WITH_DISABLED_REORDERING = [SELECT_ROW_COLUMN_ID, ISSUE_TYPE, 'key'];
export const CATEGORY_LIST_VIEW_ITEM = 'JWMCategoryCustomField';
export const DEFAULT_CACHE_VARIABLES = { jql: '' };
export const PLACEHOLDER_COLUMN = 'PLACEHOLDER';
